import Viewer from './GridFieldsViewer';
import GridFieldsEditor from './GridFieldsEditor';

export const GridFieldsViewer = Viewer;
export default GridFieldsEditor;
